import {toggleMark} from "tiptap-commands/src";
import { Mark } from 'tiptap';

export default class TextHighlightExtension extends Mark {
    get name() {
        return "highlight";
    }

    get schema() {
        return {
            attrs: {
                backgroundColor: {
                    default: "white"
                }
            },
            parseDOM: [
                {
                    style: "background-color",
                    getAttrs: value => ({
                        backgroundColor: value
                    })
                }
            ],
            toDOM: mark => ["span",
                {style: `background-color: ${mark.attrs.backgroundColor};`
                }, 0]
        };
    }

    commands({ type }) {
        return attrs => toggleMark(type, attrs);
    }

}